export const COURSE_THEMES_API = `/api/customer/membership/course-theme`

export const APPLY_THEME_API = (courseId: number, themeId: number) =>
  `/api/customer/membership/courses/${courseId}/set-theme/${themeId}`

export const UNSET_THEME_API = (courseId: number) =>
  `/api/customer/membership/courses/${courseId}/unset-theme`
